<template>
  <div style="width: 70px">
    <v-row no-gutters>
      <v-col cols="12">
        <v-progress-circular v-if="loading" indeterminate color="primary" size="18" style="margin-top: 3px;margin-bottom: 2px" width="2"/>
        <v-badge v-else-if="count>0" :content="count" class="pt-1" inline/>
        <span v-else class="text-no-wrap"><v-icon>{{icon}}</v-icon></span>
      </v-col>
      <v-col cols="12" class="caption text-no-wrap" style="font-size: 10px !important;">{{name}}</v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  props:['name','icon','count','loading'],
}
</script>